(function() {
  function forceUnlock() {
    try {
      document.documentElement.removeAttribute('scroll-lock');
      var b = document.body;
      if (b) {
        b.style.position = '';
        b.style.top = '';
        b.style.width = '';
        b.style.overflow = '';
      }
    } catch (e) {}
  }

  function isCartDrawerOpen() {
    var d = document.querySelector('cart-drawer-component dialog[open]');
    return !!d;
  }

  // Fire on Horizon's own dialog:close event
  document.addEventListener('dialog:close', function() {
    // Delay so Horizon's own cleanup gets first shot; then belt-and-suspenders.
    setTimeout(function() {
      if (!isCartDrawerOpen()) forceUnlock();
    }, 400);
  }, true);

  // Also watch <html> attribute mutations. If scroll-lock hangs > 500ms after
  // the dialog has actually closed, force it off.
  var stuckCheckTimer = null;
  var mo = new MutationObserver(function(muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'attributes' && m.attributeName === 'scroll-lock') {
        clearTimeout(stuckCheckTimer);
        if (document.documentElement.hasAttribute('scroll-lock')) {
          // Verify a dialog is actually open. If not within 800ms, force off.
          stuckCheckTimer = setTimeout(function() {
            if (document.documentElement.hasAttribute('scroll-lock') && !isCartDrawerOpen()) {
              forceUnlock();
            }
          }, 800);
        }
      }
    }
  });
  if (document.documentElement) {
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['scroll-lock'] });
  }

  // Escape key safety
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') setTimeout(function() { if (!isCartDrawerOpen()) forceUnlock(); }, 300);
  });
})();
